import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import '../../css/phone/phone.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { changeJanusStatus } from '../../redux/parametersSlice';
import Toastr from '../utils/toastr';

class Ringing extends Component {

    constructor() {
        super();
        this.copy = this.copy.bind(this);
        this.toastrRef = React.createRef();
    }

    async copy() {
        try {
            await navigator.clipboard.writeText(this.props.phoneStatus.party.length > this.props.party.length ? this.props.phoneStatus.party : this.props.party);
            this.toastrRef.current.setType("info");
            this.toastrRef.current.setMessage(this.props.t("textcopied"));
            this.toastrRef.current.show();
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert("Failed to copy text. Please ensure the page is focused and permissions are granted.");
        }
    }
    render() {
        return (
            <div className='ringing' >
                <Row>
                    <Col>
                        {
                            (this.props.phoneStatus.inbound) &&
                            <div className='direction'><FontAwesomeIcon icon={duotone('arrow-down-left')} /><span> {this.props.t("incomingcall")}</span></div>
                        }
                        {
                            (!this.props.phoneStatus.inbound) &&
                            <div className='direction'><FontAwesomeIcon icon={duotone('arrow-up-right')} /><span> {this.props.t("outgoingcall")}</span></div>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {/* //! TODO: FIX THIS */}
                        <div className='fs-7'>{this.props.groupName}</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className='direction'>{this.props.partyName ? this.props.partyName : this.props.t("unknown")}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='direction'>{this.props.phoneStatus.party.length > this.props.party.length ? this.props.phoneStatus.party : this.props.party}<Button size='sm' onClick={this.copy}><FontAwesomeIcon icon={duotone('copy')} /></Button></div>
                    </Col>
                </Row>
                <Row className='answerhangup'>

                    <Col></Col>


                    <Col>
                        {
                            this.props.functions.answer &&
                            <button className='answer' onClick={this.props.answer} ><FontAwesomeIcon size='3x' icon={faPhone} /></button>
                        }
                    </Col>
                    <Col>
                        {
                            this.props.functions.hangup &&
                            <button className='hangup' onClick={this.props.hangup}> <FontAwesomeIcon size='3x' icon={solid('phone-hangup')} /></button>
                        }
                    </Col>

                    <Col></Col>
                </Row>
                <br />
                {
                    (this.props.functions.blindTransfer) &&
                    <Row>
                        <Col>
                            <button className='phonekey' onClick={this.props.toggleTransfer}
                                disabled={this.props.phoneStatus.heldCallGUID && this.props.phoneStatus.activeCallGUID && this.props.phoneStatus.heldCallGUID !== this.props.phoneStatus.activeCallGUID}>
                                <FontAwesomeIcon icon={duotone('arrow-right')} />
                                <div className="fs-7">{this.props.t("redirect")}</div>
                            </button>
                        </Col>
                    </Row>
                }
                <Toastr ref={this.toastrRef} />
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        groupName: state.agent.groupName,
        party: state.agent.party,
        partyName: state.agent.partyName,
        functions: state.agent.functions,
        phoneStatus: state.agent.phoneStatus
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(Ringing);